import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Filter, FilterOperation, HasFilter, NotFilter } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { CountriesRegionsService } from '../../common/_services/countries-regions.service';
import { ZonesService } from '../../zones/_services/zones.service';
import { CasesServicesService } from '../../cases/_services/cases-services.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { SessionStorageService } from 'angular-web-storage';
import { DateUtilsService } from 'src/app/core/services/date-utils.service';
import { WorkersService } from '../../workers/_services/workers.service';
import { UsersService } from '../../users/_services/users.service';
import { CaseService } from '../../cases/_types/case-service';
import { Company } from '../../companies/_types/company';
import { User } from '../../users/_types/user';
import { Contract } from '../../companies/_types/contract';
import { ContractsService } from '../../companies/_services/contracts.service';
import { CompaniesService } from '../../companies/_services/companies.service';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';

type FilterOption = { label: string; value: any };

@Component({
    selector: 'app-cases-pending-approval-list',
    templateUrl: './cases-pending-approval-list.component.html',
    styleUrls: ['./cases-pending-approval-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class CasesPendingApprovalListComponent implements OnInit {


    public operatorOptions: { label: string; value: string }[] = [];
    public countriesRegions: any[] = [];
    public filters: any = {
        companyId: new Filter(FilterOperation.any, 'case.companyId'),
        contractId: new Filter(FilterOperation.any, 'case.contractId'),
        deleted: new Filter(FilterOperation.equals, 'case.deleted', '', false),
        isConfirmed: new Filter(FilterOperation.equals, 'isConfirmed', '', false),
        isCancelled: new Filter(FilterOperation.equals, 'isCancelled', '', false),
        isFailed: new Filter(FilterOperation.equals, 'isFailed', '', false),
        caseNumber: new Filter(FilterOperation.contains, 'case.caseNumber'),
        countryRegionId: new Filter(FilterOperation.equals, 'case.address.countryRegionId'),
        zoneId: new HasFilter('workerZones', new Filter(FilterOperation.equals, 'zoneId')),
        dateFrom: new Filter(FilterOperation.greaterOrEqual, 'date'), 
        dateTo: new Filter(FilterOperation.lessThan, 'date'),
        createdAtFrom: new Filter(FilterOperation.greaterOrEqual, 'createdAt'), 
        createdAtTo: new Filter(FilterOperation.lessThan, 'createdAt'),
        workerId: new Filter(FilterOperation.equals, 'workerId'),
        processorId: new Filter(FilterOperation.equals, 'case.processorId'),
        zipCode: new Filter(FilterOperation.contains, 'case.address.zipCode'),
        city: new Filter(FilterOperation.contains, 'case.address.city'),
        caseNotStateFinal: new Filter(FilterOperation.equals, 'case.caseState.isFinal', '', null, false),
    };
    public casesServices: any[] = [];
    public totalRecords: number = 0;
    private lastGridEvent: any;
    public workers: any[] = [];
    public users: any[] = [];

    public companies: Company[] = [];
    public contracts: Array<Contract> = new Array<Contract>();
    public activeOptions: any[] = [
        { id: null, name: 'Todos' },
        { id: false, name: 'Activo' },
        { id: true, name: 'Inactivo' }
    ];

    public workerOptions: FilterOption[] = [];
    public userOptions: FilterOption[] = [];
    public companyOptions: FilterOption[] = [];
    public contractOptions: FilterOption[] = [];
    public regionOptions: FilterOption[] = [];
    private lastCompanySignature: string = 'null';

    public fieldsConfig: FilterFieldConfig[] = [
        { filter: this.filters.workerId, type: 'select', label: 'Operario', options: this.workerOptions, filterable: true, base: true },
        { filter: this.filters.companyId, type: 'multiselect', label: 'Compañía', options: this.companyOptions, base: true },
        { filter: this.filters.dateFrom, filterTo: this.filters.dateTo, type: 'date', label: 'Fecha cita', base: true },
        { filter: this.filters.caseNotStateFinal, type: 'select', label: 'Estado expediente', options: [{ label: 'Activo', value: false }, { label: 'Inactivo', value: true }], base: true },
        { filter: this.filters.processorId, type: 'select', label: 'Responsable', options: this.userOptions, filterable: true },
        { filter: this.filters.contractId, type: 'multiselect', label: 'Contrato', options: this.contractOptions },
        { filter: this.filters.createdAtFrom, filterTo: this.filters.createdAtTo, type: 'date', label: 'Fecha creación cita' },
        { filter: this.filters.zipCode, type: 'text', label: 'Código postal' },
        { filter: this.filters.city, type: 'text', label: 'Ciudad' },
        { filter: this.filters.countryRegionId, type: 'select', label: 'Provincia', options: this.regionOptions, filterable: true }
    ];

    constructor(
        private countriesRegionsService: CountriesRegionsService,
        private usersService: UsersService,
        private casesServicesService: CasesServicesService,
        private workersService: WorkersService,
        private topbarService: TopbarService,        
        private route: ActivatedRoute,
        private sessionStorage: SessionStorageService,
        private dateUtilsService: DateUtilsService,
        private contractsService: ContractsService,
        private companiesService: CompaniesService
    ) { }
    
    ngOnInit(): void {
        this.topbarService.setTitle("Servicios pendientes de confirmar");
    
        this.route.paramMap.subscribe((params: ParamMap) => {          
           this.topbarService.addAction("Exportar a excel", "pi pi-file-excel", false, () => {
              this.exportToExcel();
            });    
        });
             //recuperar filtros guardados
        let savedFilters = this.sessionStorage.get("casesServicesPendingApprovalFilters");
        if (savedFilters != null) FilterBuilder.loadSavedFilters(this.filters, savedFilters);
        if(this.filters.dateFrom.value) this.filters.dateFrom.value = new Date(this.filters.dateFrom.value);
        if(this.filters.dateTo.value) this.filters.dateTo.value = new Date(this.filters.dateTo.value);
        if(this.filters.createdAtFrom.value) this.filters.createdAtFrom.value = new Date(this.filters.createdAtFrom.value);
        if(this.filters.createdAtTo.value) this.filters.createdAtTo.value = new Date(this.filters.createdAtTo.value);
        
        this.loadCompanies();
        this.loadCountriesRegions();
        this.loadUsers();
        this.loadWorkers(null);
        this.loadWorkerOptions();
        this.refreshContracts();
    }

    private async loadWorkerOptions() {
        let params: IParamsCollection = {
            sort: ['name'],
            page: { size: 5000 },
            fields: { workers: 'name' }
        };
        let response = await firstValueFrom(this.workersService.all(params));
        this.fillOptions(this.workerOptions, response.data);
    }

    private fillOptions(target: FilterOption[], items: any[]) {
        target.length = 0;
        target.push(...items.map(item => ({ label: item.name, value: item.id })));
    }

    private async refreshContracts() {
        const signature = JSON.stringify(this.filters.companyId.value ?? null);
        if (signature === this.lastCompanySignature) return;
        this.lastCompanySignature = signature;

        let items: Contract[] = [];
        if (this.filters.companyId.value != null) {
            let params: IParamsCollection = {
                sort: ['name'],
                page: { number: 1, size: 1000 },
                filter: FilterBuilder.fromObject({ companyId: new Filter(FilterOperation.any, 'companyId', '', this.filters.companyId.value) }).build()
            };
            let response = await firstValueFrom(this.contractsService.all(params));
            items = response.data;
        }
        this.contracts = items;
        this.fillOptions(this.contractOptions, items);
    }
    
    
    private async loadCountriesRegions(): Promise<void> {
        const response = await firstValueFrom(this.countriesRegionsService.all());
        this.countriesRegions = response.data;
        this.fillOptions(this.regionOptions, response.data);
    }
    

    async loadUsers(event?: any) {
      let text = "";
        if (event != null) text = event.filter; 
        let filters = {
          name: new Filter(FilterOperation.contains, 'name', '', text),
          isWorker: new Filter(FilterOperation.equals, 'isWorker', '', false)   
        };
        let params: IParamsCollection = {
          sort: ['name'],
          page: { number: 1, size: 1000 },
          filter: FilterBuilder.fromObject(filters).build()
        };
        let response = await firstValueFrom(this.usersService.all(params));
        this.users = response.data;
        if (event == null) this.fillOptions(this.userOptions, response.data);
      }


    
    async loadWorkers(event: any){
    let text = "";       
        if (event != null) text = event.filter; 
        
        let filters: any = { };
        if(text != "" && text.length >= 3) filters.name = new Filter(FilterOperation.contains, 'name', "", text);
        //creamos filtros
        let params: IParamsCollection = {
            sort: ['name'],
            page: { size: 200 },
            fields: { workers: 'name' }
        }
        params.filter = FilterBuilder.fromObject(filters).build();
        let response = await firstValueFrom(this.workersService.all(params));
        this.workers = response.data;
    }

    public async loadData($event: any){

        this.lastGridEvent = $event;
        if (this.filters.contractId.value == '') this.filters.contractId.value = null;
        if (this.filters.companyId.value == '') this.filters.companyId.value = null;
        
        let params: IParamsCollection = {       
            filter: FilterBuilder.fromObject(this.filters).build(),
            //page: { size: $event.rows, number: ($event.first / $event.rows) + 1 },
            page: { number: $event.first + 1, size: $event.rows },
            include: ['worker','client', 'case', 'case.processor', 'case.address.countryRegion', 'capability'/*, 'cancelCaseServiceCause', 'cancelCaseServiceReason'*/], //, 'case.contract.zone'
        };
        
        if ($event.sortField) {
          params.sort = [($event.sortOrder > 0 ? '' : '-') + $event.sortField];
        }
        let response = await firstValueFrom(this.casesServicesService.all(params));
        this.casesServices = response.data;
        this.totalRecords = response.meta["total"];
        this.topbarService.setCount(this.totalRecords);
        
        //guardamos los filtros en la sesion
        this.sessionStorage.set("casesServicesPendingApprovalFilters", this.filters);
    }

    public async search(){
        await this.refreshContracts();
        this.lastGridEvent.first = 0;
        this.loadData(this.lastGridEvent);
    }
    /*
    clearFilters() {
        this.filters = {
            companyId: new Filter(FilterOperation.any, 'case.companyId'),
            contractId: new Filter(FilterOperation.any, 'case.contractId'),
            deleted: new Filter(FilterOperation.equals, 'case.deleted', '', false),
            isConfirmed: new Filter(FilterOperation.equals, 'isConfirmed', '', false),
            isCancelled: new Filter(FilterOperation.equals, 'isCancelled', '', false),
            isFailed: new Filter(FilterOperation.equals, 'isFailed', '', false),
            caseNumber: new Filter(FilterOperation.contains, 'case.caseNumber'),
            countryRegionId: new Filter(FilterOperation.equals, 'case.address.countryRegionId'),
            zoneId: new HasFilter('workerZones', new Filter(FilterOperation.equals, 'zoneId')),
            dateFrom: new Filter(FilterOperation.greaterOrEqual, 'date'), 
            dateTo: new Filter(FilterOperation.lessThan, 'date'),
            createdAtFrom: new Filter(FilterOperation.greaterOrEqual, 'createdAt'), 
            createdAtTo: new Filter(FilterOperation.lessThan, 'createdAt'),
            workerId: new Filter(FilterOperation.equals, 'workerId'),
            processorId: new Filter(FilterOperation.equals, 'case.processorId'),
            zipCode: new Filter(FilterOperation.contains, 'case.address.zipCode'),
            city: new Filter(FilterOperation.contains, 'case.address.city'),
            caseNotStateFinal: new Filter(FilterOperation.equals, 'case.caseState.isFinal', '', null, false)
        };
        this.search();
    }
    */

    exportToExcel() {
        this.casesServicesService.casesservicesPendingApprovalExcel(
            this.filters.workerId.value, 
            this.filters.processorId.value,
            this.filters.dateFrom.value,
            this.filters.dateTo.value,
            this.filters.createdAtFrom.value,
            this.filters.createdAtTo.value,
            this.filters.countryRegionId.value,
            this.filters.zoneId.value,
            this.filters.caseNumber.value,
            this.filters.zipCode.value,
            this.filters.city.value
        );
    }
        
      getTimeAgo(date?: Date) {
        if(date==null) return "";
        return this.dateUtilsService.getTimeAgo(date);
      }
    /*  
    isOnTime(service:CaseService):boolean{
        let now = new Date();
        return !service.isFailed && !service.isCancelled && service.workerAttendanceStatus!='rejected' && service.workerAttendanceStatus!='rejected_day' && service.date>now;
    }
    
    isTooLate(service:CaseService):boolean{
        let now = new Date();
        return !service.isFailed && !service.isCancelled && service.workerAttendanceStatus!='rejected' && service.workerAttendanceStatus!='rejected_day' && service.date<now && service.dateStart==null;
    }
    
    isStarted(service:CaseService):boolean{
        return !service.isFailed && !service.isCancelled && service.workerAttendanceStatus!='rejected' && service.workerAttendanceStatus!='rejected_day' && service.dateStart!=null && service.dateEnd==null;
    }
    
    isEnded(service:CaseService):boolean{
        return !service.isFailed && !service.isCancelled && service.workerAttendanceStatus!='rejected' && service.workerAttendanceStatus!='rejected_day' && service.dateStart!=null && service.dateEnd!=null;
    }
    
    isRejected(service:CaseService):boolean{
        return service.workerAttendanceStatus=='rejected' || service.workerAttendanceStatus=='rejected_day';
    }
    
    isFailed(service:CaseService):boolean{
        return service.isFailed && service.workerAttendanceStatus!='rejected' && service.workerAttendanceStatus!='rejected_day';
    }
    
    isCancelled(service:CaseService):boolean{
        return service.isCancelled;
    }*/
    async loadCompanies() {
        let params: IParamsCollection = {
            sort: ['name'],
            page: { number: 1, size: 1000 }
        };
        let response = await firstValueFrom(this.companiesService.all(params));
        this.companies = response.data;
        this.fillOptions(this.companyOptions, response.data);
    }
    /*
    async companyChanged() {
        
        if (this.filters.companyId.value != null) {
        let filters = {
        companyId: new Filter(FilterOperation.any, 'companyId', "", this.filters.companyId.value)
        };
        
        let params: IParamsCollection = {
        sort: ['name'],
        page: { number: 1, size: 1000 },
        filter: FilterBuilder.fromObject(filters).build()
        };
        
        let response = await firstValueFrom(this.contractsService.all(params));
        this.contracts = response.data;
        this.search();
        } else {
        this.contracts = [];
        this.search()
        }
    }
    */
}
